
const state = {
  pointerExt: 'Altro_mondo/'
}

const mutations = {

}

const actions = {

}

export default {
  namespaced: true,
  state,
  // getters,
  actions,
  mutations
}